import { observer } from "mobx-react";
import React from "react";
import ContactCondition from "./ContactCondition";
import ContactLeadCondition from "./ContactLeadCondition";

const AddContactWithCondition = observer(props => {
  const { fields = {}, type = "LEADS" } = props || {};

  return (
    <div className={"sectionMarginBottom addContactsWrapper"}>
      <div className="flexColumn">
        <div className="updateContactsCont">
          <span className="headingText">{`${
            type === "LEADS" ? "Import Leads" : "Import Contacts"
          }`}</span>
        </div>
        <span className="headingSubText">
          {`${type === "LEADS" ? "Leads" : "Contacts"}`} that match the below
          conditions will be imported from Salesforce CRM to SalesIntel
        </span>
      </div>
      {type === "LEADS" ? (
        <ContactLeadCondition fields={fields} {...props} />
      ) : (
        <ContactCondition fields={fields} {...props} />
      )}
    </div>
  );
});

export { AddContactWithCondition };
export default AddContactWithCondition;
